<template lang="pug">
div.input
    label.tech.grey {{ label }}
    textarea.input-field(:value="value" @input="updateValue($event.target.value)" :placeholder="placeholder")
</template>

<script>
import Input from './Input.vue';
export default {
    name: 'textarea-input',
    extends: Input
}
</script>

<style lang="scss" scoped>
textarea.input-field {
    height: 130px;
    resize: none;
    &::placeholder {
        padding-top: 7px;
    }
}
</style>



// WEBPACK FOOTER //
// TextareaInput.vue?a808bd72